<template>
  <div
    class="status-progress"
    :class="{ 'status-progress--dense': dense }"
  >
    <div class="status-progress__top">
      <span
        v-if="!dense"
        class="status-progress__label"
      >
        {{ label }}
      </span>
      <BaseStatusPill
        :label="stageLabel"
        :variant="variant"
        :dense="dense"
      />
      <span
        v-if="dense"
        class="status-progress__percent"
      >
        {{ percent }}%
      </span>
    </div>
    <div class="status-progress__bar">
      <div
        class="status-progress__fill"
        :class="`status-progress__fill--${variant}`"
        :style="{ width: `${percent}%` }"
      />
    </div>
    <div class="status-progress__meta">
      <span><b>Início</b> {{ startAt }}</span>
      <span v-if="endAt"><b>Fim</b> {{ endAt }}</span>
    </div>
  </div>
</template>

<script>
import BaseStatusPill from './BaseStatusPill.vue'

export default {
  name: 'BaseStatusProgress',
  components: { BaseStatusPill },
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    variant: {
      type: String,
      required: true,
      validator: (value) => ['success', 'warning', 'error', 'info'].includes(value)
    },
    stageLabel: {
      type: String,
      required: true
    },
    percent: {
      type: Number,
      required: true
    },
    startAt: {
      type: String,
      required: true
    },
    endAt: {
      type: String,
      required: false,
      default: ''
    },
    dense: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss">
.status-progress {
  &__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.875rem;
    margin-bottom: 6px;
  }

  &__label {
    color: var(--ds-color-black-055);
    font-weight: 500;
  }

  &__percent {
    font-weight: 700;
    font-variant-numeric: tabular-nums;
  }

  &__bar {
    background: var(--ds-color-black-010);
    border-radius: 4px;
    height: 7px;
    overflow: hidden;
  }

  &__fill {
    height: 100%;
    border-radius: 4px;
    transition: width 0.2s ease;

    &--success {
      background: var(--v-success-base);
    }

    &--info {
      background: var(--v-bluefa-base);
    }

    &--warning {
      background: var(--v-warning-base);
    }

    &--error {
      background: var(--v-error-base);
    }
  }

  &__meta {
    display: flex;
    gap: 14px;
    margin-top: 6px;
    font-size: 0.75rem;
    color: var(--ds-color-black-040);

    b {
      color: var(--ds-color-black-055);
      font-weight: 600;
      margin-right: 3px;
    }
  }

  &--dense {
    .status-progress__top {
      margin-bottom: 4px;
    }

    .status-progress__meta {
      margin-top: 4px;
    }
  }
}
</style>
